import { Link } from "react-router-dom";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { useSite } from "../context/SiteContext";
import { GALLERY_PHOTOS } from "../lib/site";

export default function Privacy() {
  const { settings } = useSite();
  const sections = [
    {
      id: "what-we-collect",
      title: "What we collect",
      items: [
        "Contact details you share with us — your name, phone number, email address and stay dates — when you send a booking request, enquiry, or message us on WhatsApp.",
        "Stay preferences and notes you choose to share, such as celebrations, dietary needs or arrival times.",
        "Payment confirmations and receipts you share with our reservations desk to confirm a booking.",
      ],
    },
    {
      id: "how-we-use",
      title: "How we use your information",
      items: [
        "To respond to your enquiry and confirm your reservation.",
        "To prepare your stay — room setup, dining preferences and special requests.",
        "To contact you about your booking on phone, email or WhatsApp.",
        "We never sell, rent or share your personal details with third parties beyond what is required to fulfil your booking.",
      ],
    },
    {
      id: "analytics",
      title: "Website analytics & advertising",
      items: [
        "Our website records anonymised interaction events (such as button clicks on Call, WhatsApp and Book Now) to measure our Google Ads campaigns and improve the website.",
        "These events do not include your personal details unless you voluntarily share them in a form.",
        "You can browse the entire website without sharing any personal information.",
      ],
    },
    {
      id: "your-rights",
      title: "Your choices & rights",
      items: [
        `To review, correct or remove your information, write to us at ${settings.email} or call ${settings.phone_display}.`,
        "WhatsApp conversations and payment receipts are used solely to handle your reservation and are not shared further.",
        "If you have booked with us before and would like your records removed, we will do so within 7 working days of your request.",
      ],
    },
  ];
  return (
    <main>
      <PageHero
        image={GALLERY_PHOTOS[2]}
        eyebrow="Privacy Policy"
        lines={[<>Your privacy,</>, <em>respected.</em>]}
        lede="What we collect, why we collect it, and the control you always have — written plainly."
      />
      <section className="section-pad intro" data-testid="privacy-sections">
        {sections.map((section) => (
          <Reveal key={section.id} className="policy-block" data-testid={`privacy-${section.id}`}>
            <h2 id={section.id}>{section.title}</h2>
            <ul>
              {section.items.map((item) => <li key={item}>{item}</li>)}
            </ul>
          </Reveal>
        ))}
        <Reveal className="policy-block">
          <p className="muted" data-testid="privacy-footer-note">
            Also read our <Link to="/policies" className="text-link" data-testid="privacy-policies-link">Terms &amp; Cancellation policy</Link> for
            check-in times, payments and cancellations. Last updated: September 2026.
          </p>
        </Reveal>
      </section>
    </main>
  );
}
